
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/take-back",
      function () {
        return require("private-next-pages/take-back.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/take-back"])
      });
    }
  